<template>
    <div class="container-progression">
        <div id="barre-progression" :style="{ width: progression_annee + '%' }"></div>
    </div>
    <p id="score-annee">
        {{ joueur_list_scores.annee?.score }}
    </p>
</template>
  
<script>
export default {
    name: 'ProgressBarComponent',
    props: {
        joueur_list_scores: {
            type: Object,
            required: true,
        },
    },
    computed: {
        progression_annee() {
            // Récupérer les valeurs nécessaires à partir de l'objet joueur_list_scores
            const anneeActuel = this.joueur_list_scores.annee?.score;
            const anneeDebut = this.joueur_list_scores.annee?.parametres.min_score;
            const anneeFin = this.joueur_list_scores.annee?.parametres.max_score;
    
            // Calculer le nombre total d'années pour déterminer le progrès
            const deltaAnnee = anneeFin - anneeDebut;
    
            // Calculer le pourcentage de progression en fonction des valeurs fournies
            const progressionPercentage = ((anneeActuel - anneeDebut) / deltaAnnee) * 100;
    
            // S'assurer que la progression est comprise entre 0 et 100
            return Math.min(Math.max(progressionPercentage, 0), 100); 
        },
    },
};
</script>